<template>
  <div>
    <Header />
    <div class="service-wrapper">
      <div class="subfixed">
        <div>{{$t('当前位置')}}</div>
        <div>{{$t('联系我们')}}</div>
      </div>
      <div class="sub-box">
        <div class="title">{{$t('银行客服联系方式')}}</div>
        <div class="service-contact-container">
          <div class="service-contact-container-header box border">
            <div class="img">
              <img
                src="~@/assets/image/service_contact/service.png"
                alt=""
              />
            </div>
            <div class="desc-box">
              <div class="desc-box-header">{{$t('客服热线')}}</div>
              <div class="desc-box-footer">
                <span>+1 939-332-7285（{{$t('美国地区')}}）</span>
                <span>+ 86 400-022-9291（{{$t('中国大陆地区')}}）</span>
              </div>
            </div>
          </div>
          <ul class="service-contact-container-ul">
            <li class="box border">
              <div class="img">
                <img
                  src="~@/assets/image/service_contact/email.png"
                  alt=""
                />
              </div>
              <div class="desc-box ">
                <div class="desc-box-header">{{$t('联系邮箱')}}</div>
                <div class="desc-box-footer">support@cbibank.com</div>
              </div>
            </li>
            <li class="box border">
              <div class="img">
                <img
                  src="~@/assets/image/service_contact/adress.png"
                  alt=""
                />
              </div>
              <div class="desc-box ">
                <div class="desc-box-header">{{$t('联系地址')}}</div>
                <div class="desc-box-footer">
                  ST 330，270 Munoz Rivera Ave，San Juan，Puerto Rico，United States 00918
                </div>
              </div>
            </li>
          </ul>
          <div class="service-contact-container-header box border">
            <div class="img img-code">
              <img
                src="~@/assets/image/service_contact/code.png"
                alt=""
              />
            </div>
            <div class="desc-box">
              <div class="desc-box-header">{{$t('微信公众号')}}</div>
              <div class="desc-box-footer">
                {{$t('微信搜索CBiBank公众号或者直接扫描左侧二维码')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <QuickEntry />
    <TipBar style="bottom: 80px;" />
    <Footer />
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.service-wrapper {
  padding: 40px 60px;
  background: #f6f7fc;
  height: calc(100vh - 214px);
  min-height: 650px;

  .subfixed {
    font-size: 14px;
    font-weight: 300;
    color: #5a607f;
    line-height: 14px;
    display: flex;
    div {
      &:first-child {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          right: -20px;
          width: 0;
          height: 0;
          transform: translateY(-50%);
          border-top: 3px solid transparent;
          border-right: 3px solid transparent;
          border-left: 6px solid #d7dbec;
          border-bottom: 3px solid transparent;
        }
      }
      + div {
        margin-left: 26px;
      }
    }
  }
  .sub-box {
    margin-top: 28px;
    padding: 40px 80px;
    background: @white;
    border-radius: 4px;
    height: calc(100% - 40px);
    min-height: 550px;

    .title {
      font-size: 20px;
      font-weight: 500;
      color: #131523;
      line-height: 20px;
      margin-bottom: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .service-contact-container {
      font-size: 14px;
      max-width: 780px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
      .border {
        border: 1px solid #d3d5db;
      }
      .box {
        padding: 20px 20px 20px 20px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 46px;
        height: 46px;
        margin-right: 20px;
        background: #f6f7fc;
        border-radius: 50%;
        img {
          width: 28px;
          height: 28px;
        }
      }
      .img-code {
        width: 102px;
        height: 100px;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .desc-box {
        flex: 1 1 0%;
        .desc-box-header,
        .desc-box-footer {
          font-weight: 400;
          color: #545866;
          line-height: 24px;
        }
        .desc-box-footer {
          font-weight: 400;
          color: #161d29;
          margin-top: 5px;
          span {
            margin-right: 40px;
          }
        }
      }
      .service-contact-container-ul {
        display: flex;
        li {
          display: flex;
          flex: 1 1 0%;
          &:first-child {
            margin-right: 20px;
          }
        }
      }
    }
  }
}
</style>
